import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { MIN_PLAYER_QUERY, usePlayers } from '../api/hooks';
import { PageHeader } from '../app/Shell';
import { ROLE_LABEL, USER_STATUS } from '../app/labels';
import { Badge, Card, DataTable, Empty, Id, QueryView, fmtAgo, fmtDateTime } from '../ui';

/** Find a player by email (or its start), display name, player ID or user id. */
export function UsersPage() {
  const [params, setParams] = useSearchParams();
  const [text, setText] = useState(params.get('q') ?? '');
  const q = (params.get('q') ?? '').trim();
  const players = usePlayers(q);
  const navigate = useNavigate();

  // Search as you type, a moment after the last key.
  useEffect(() => {
    const t = window.setTimeout(() => setParams(text.trim() ? { q: text.trim() } : {}, { replace: true }), 300);
    return () => window.clearTimeout(t);
  }, [text, setParams]);

  return (
    <>
      <PageHeader title="玩家" description="以電郵（或開頭幾個字）、顯示名稱、玩家 ID 或 user ID 搜尋。點擊一行查看完整帳戶。" />
      <Card flush>
        <div style={{ padding: 'var(--sp-3)' }}>
          <input type="search" autoFocus placeholder="例如 tommy@、AB12CD34、01J…" aria-label="搜尋玩家" value={text} onChange={(e) => setText(e.target.value)} />
        </div>
        <QueryView query={players} loading="搜尋中…" idle={<Empty>輸入最少 {MIN_PLAYER_QUERY} 個字開始搜尋。</Empty>}>
          {(rows) => (
            <DataTable pageSize={25}
              rows={rows}
              rowKey={(r) => r._id}
              onRowClick={(r) => navigate(`/users/${r._id}`)}
              empty="找不到符合的玩家。"
              columns={[
                { key: 'email', header: '電郵', render: (r) => r.email ?? <span className="faint">訪客</span>, sort: (r) => r.email ?? '' },
                { key: 'name', header: '角色 / 顯示名稱', render: (r) => r.characterName ?? r.displayName ?? <span className="faint">—</span> },
                { key: 'code', header: '玩家 ID', render: (r) => <code>{r.publicId}</code> },
                { key: 'status', header: '狀態', render: (r) => <Badge tone={USER_STATUS[r.status].tone}>{USER_STATUS[r.status].label}</Badge>, sort: (r) => r.status },
                { key: 'roles', header: '後台角色', render: (r) => (r.adminRoles.length ? r.adminRoles.map((x) => ROLE_LABEL[x]).join('、') : <span className="faint">—</span>) },
                { key: 'created', header: '註冊', render: (r) => <span title={fmtDateTime(r.createdAt)}>{fmtAgo(r.createdAt)}</span>, sort: (r) => r.createdAt },
                { key: 'active', header: '最後活動', render: (r) => <span title={fmtDateTime(r.lastActiveAt)}>{fmtAgo(r.lastActiveAt)}</span>, sort: (r) => r.lastActiveAt },
                { key: 'id', header: 'ID', render: (r) => <Id value={r._id} /> },
              ]}
            />
          )}
        </QueryView>
      </Card>
    </>
  );
}
